import {
  NavVoucherIcon,
  NavLogsIcon,
  NavAnnouncementIcon,
  NavUserIcon,
  NavFinanceIcon,
  NavExamIcon,
  NavHomeIcon,
  NavProfileIcon,
} from "../assets/navIcons";
import Profile from "../pages/Profile";
import ATCExam from "../pages/exams/ATCExam";
import ATCUsers from "../pages/users/ATCUsers";
import FinanceAtc from "../pages/finance/FinanceAtc";
import ATCHome from "../pages/home/ATCHome";
import ATCAnnoucementTable from "../pages/announcement/ATCAnnouncementTable";
import ATCVoucherManagement from "../pages/voucherManagement/ATCVoucherManagement";
import ATCLogs from "../pages/logs/ATCLogs";
import ATCVoucherDetail from "../pages/voucherManagement/ATCVoucherDetail";
import { DashbordRoute } from "./adminRoutes";

const atcRoutes: DashbordRoute[] = [
  {
    key: "0",
    Icon: NavProfileIcon,
    label: "Profile",
    path: "profile",
    Component: Profile,
    hidden: true,
  },
  {
    key: "1",
    Icon: NavHomeIcon,
    label: "Home",
    path: "home",
    Component: ATCHome,
    group: "Overview",
  },

  {
    key: "2",
    Icon: NavExamIcon,
    label: "Exam",
    path: "exam",
    Component: ATCExam,
    search: true,
    group: "Exams",
  },
  {
    key: "6",
    Icon: NavVoucherIcon,
    label: "Voucher Management",
    path: "voucher-management",
    Component: ATCVoucherManagement,
    search: true,
  },
  {
    key: "61",
    Icon: NavVoucherIcon,
    label: "Voucher Management",
    path: "voucher-management/:id",
    Component: ATCVoucherDetail,
    hidden: true,
  },
  {
    key: "10",
    Icon: NavUserIcon,
    label: "Users",
    path: "user",
    Component: ATCUsers,
    search: true,
    group: "People",
  },
  {
    key: "7",
    Icon: NavLogsIcon,
    label: "Logs",
    path: "logs",
    Component: ATCLogs,
    search: true,
    group: "Insights",
  },
  {
    key: "11",
    Icon: NavFinanceIcon,
    label: "Finance",
    path: "finance",
    Component: FinanceAtc,
    search: true,
  },
  {
    key: "9",
    Icon: NavAnnouncementIcon,
    label: "Announcement",
    path: "announcement",
    Component: ATCAnnoucementTable,
    search: true,
    group: "Updates",
  },
];

export default atcRoutes;
